import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { sm, xs, md } = constants.breakpoints.BreakpointNames;
const { ui } = constants.colors;

const greyDark = ui.neutral[700];

export const container = {
  marginBottom: "24px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  textAlign: "center",
};

export const headerWrapper = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  alignItems: "flex-start",
  justifyContent: "flex-start",

  [mq.downTo(xs)]: {
    flexDirection: "row",
  },
};

export const heading = {
  fontSize: "20px",
  margin: "0",
  lineHeight: "120%",
  color: greyDark,
  [mq.downTo(xs)]: {
    fontSize: "24px",
    lineHeight: "133%",
  },
};

export const contentWrapper = {
  width: "100%",
  display: "flex",
  gap: "16px",
  alignItems: "center",
  justifyContent: "flex-start",
  color: greyDark,
  background: "#FFF1C6",
  borderRadius: "16px",
  position: "relative",
  [mq.downTo(md)]: {
    justifyContent: "space-between",
  },
};

export const textWrapper = {
  width: "100%",
  display: "flex",
  minWidth: "288px",
  maxWidth: "536px",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  fontFamily: "Circular",
  textAlign: "initial",
  padding: "16px",
  zIndex: 2,
  gap: "16px",

  h1: {
    fontSize: "24px",
    fontWeight: "700",
    lineHeight: "133%",
    margin: "0px",
  },
  p: {
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "150%",
    margin: "0px",
  },

  [mq.downTo(xs)]: {
    padding: "24px",
    minWidth: "441px",
    maxWidth: "542px",
  },

  [mq.downTo(sm)]: {
    minWidth: "530px",
    maxWidth: "768px",
  },
};

export const imageWrapper = {
  maxWidth: "454px",
  overflow: "hidden",
  display: "flex",
  position: "absolute",
  justifyContent: "flex-start",
  top: "0px",
  right: "0px",
  [mq.downTo(xs)]: {
    height: "150px",
  },
  [mq.downTo(sm)]: {
    // width: '50%',
    height: "240px",
    position: "initial",
  },
};

export const imageCss = {
  width: "150px",
  content: 'url("/images/icons/challenge_teacher_homepage_image_small.svg")',
  [mq.downTo(xs)]: {
    content: 'url("/images/icons/challenge_teacher_homepage_image_medium.svg")',
  },
  [mq.downTo(sm)]: {
    width: "454px",
    content: 'url("/images/icons/challenge_teacher_homepage_image_large.svg")',
  },
};

export const contentDropdownWrapper = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "left",
  color: greyDark,
  background: "#FFF",
  padding: "16px",
  gap: "40px",
  [mq.downTo(xs)]: {
    padding: "40px",
  },
  [mq.downTo(md)]: {
    padding: "80px",
  },
};

export const dropDownWrapper = {
  width: "100%",
  margin: 0,
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  label: {
    fontSize: "1.5rem",
    lineHeight: "2 rem",
    fontWeight: "bold",
  },
  padding: "20px 40px",
  [mq.downTo(md)]: {
    padding: "20px 80px",
  },
};

export const comboBoxCss = {
  width: "300px",
  "& > :nth-child(1)": {
    "& > :nth-child(1)": {
      fontFamily: "Noto Serif",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "133%",
    },
  },
  ul: {
    width: "100%",
    textAlign: "left",
  },
};
